import { memo } from 'react';

import Main from './components/Main';
import { VideoPlaylistOptionsProvider, VideoPlaylistProvider } from './store';
import type { VideoPlaylistOptions } from './store/types';

const VideoPlaylist = ({ options }: { options: VideoPlaylistOptions }) => (
  <VideoPlaylistOptionsProvider options={options}>
    <VideoPlaylistProvider>
      <Main />
    </VideoPlaylistProvider>
  </VideoPlaylistOptionsProvider>
);

export default memo(VideoPlaylist);
